import i18next from 'i18next'
import * as React from 'react'

const Loading: React.SFC<{}> = ({}) => {
    return (
        <div className="AppCore__flow__ElementCamera__LoadingState">
            <zaptic-icon icon-name="play"></zaptic-icon>
            <div className="AppCore__flow__ElementCamera__LoadingState_inner">
                <zaptic-spinner></zaptic-spinner>
                {i18next.t('appcore:common.loading')}
            </div>
        </div>
    )
}

export default Loading
